import { PortableText } from '@portabletext/react'
import { PortableTextBlock } from 'sanity'

import { Column, Grid } from './Grid'

export default function PageTitle({
  title,
}: {
  title: PortableTextBlock[] | string
}) {
  return (
    <Grid>
      <Column className="col-span-12 md:col-span-10 md:col-start-2">
        <div className="flex flex-col items-start justify-center z-10 w-full mt-4 md:mt-20">
          <div className="text-center w-full">
            <h1 className="h1 text-gradient m-auto text-pretty mb-20">
              {typeof title === 'string' ? (
                title
              ) : (
                <PortableText value={title} />
              )}
            </h1>
          </div>
        </div>
      </Column>
    </Grid>
  )
}
